// extracted by mini-css-extract-plugin
export default {"snowflakeContainer":"Snowflakes_snowflakeContainer__c1Yp3","snowflake":"Snowflakes_snowflake__xoabS","fall":"Snowflakes_fall__Kxj-9"};